import React from 'react';
import { Grid, Typography, Box, Button } from '@mui/material';
import HandsOnMobile from '../assets/img/handsonmobile.jpg';
import useStyles from '../styles/styles';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { FONT_FAMILY } from 'common/sharedFunctions';

const DownloadApp = () => {
  const classes = useStyles();
  const settings = useSelector(state => state.settingsdata.settings);
  const { t } = useTranslation();

  return (
    <Box className={classes.aboutUsContainer} style={{marginBottom: -15}}>
      <Grid container spacing={4} className={classes.gridContainer}>
        <Grid item xs={12} md={5}>
          <img
            src={HandsOnMobile}
            alt="App Movex en el celular"
            className={classes.largeImage}
            style={{ borderRadius: 20, boxShadow: '0 16px 40px rgba(0,0,0,0.18)' }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="h3" fontWeight={700} fontFamily={FONT_FAMILY} className={classes.title} sx={{ fontSize: { xs: 28, md: 40 } }}>
          {t('mobile_apps_on_store')}
          </Typography>
          <Typography fontFamily={FONT_FAMILY} className={classes.aboutUsSubtitle}>
          {t('app_store_deception1')}
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'center' }}>
            {settings && settings.AppleStoreLink?
              <a href={settings.AppleStoreLink}><img src={require("../assets/img/appstore.png")} alt="Descargar en App Store" style={{ height: 52 }} /></a>
              :null}
              {settings && settings.PlayStoreLink?
              <a href={settings.PlayStoreLink}><img src={require("../assets/img/playstore.png")} alt="Disponible en Google Play" style={{ height: 52 }} /></a>
              :null}
          </Box>
          <Box sx={{ mt: 2 }}>
            <Button component={Link} to="/descargas" variant="outlined" color="secondary">
              {t('desktop_landing_cta', { defaultValue: '¿Gestionas flotas? Descarga la app de escritorio' })}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DownloadApp;